/* eslint-disable no-unused-vars */
/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS = 'ProvenceMapSlider';
const CLS = 'provenceMapSlider';
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/provenceMapSlider.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import {loadProvenceMap} from '../loadWg/provenceMap';
import utils from '../utils';

export class ProvenceMapSlider {
	constructor($el) {
		// $el is the widget node return by the loadProvenceMapSlider function
		this.$el = $el;
	}

	init() {
		this.initCarousel();
		this.loadProvenceMaps();
		this.handleIframe();
	}

	loadProvenceMaps() {
		loadProvenceMap(this.$el, true).then((wgAll) => {
			(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
				wg.init();
			}) : '';
		});
	}

	initCarousel() {
		const el = $(this.$el);
		const $carousel = el.find(`${WG}carousel`);
		const navActiveClass = 'is-active';
		const $navLinks = el.find(`${WG}navLinks`);
		const $navPrev = el.find(`${WG}navArrow--prev`);
		const $navNext = el.find(`${WG}navArrow--next`);
		let navWidth = $navLinks.outerWidth();
		let navContentWidth = $navLinks.get(0).scrollWidth;
		let scrollDistance = navContentWidth - navWidth;
		let scrollPos = 0;

		$carousel.on('init', () => {
			el.find(`${WG}navLink`).on('click', function() {
				let $this = $(this);
				let index = $this.attr('data-slide-index');

				$carousel.slick('slickGoTo', index);
				$this.siblings().removeClass(navActiveClass);
				$this.addClass(navActiveClass);
			});
		}).slick({
			arrows: false,
			fade: true,
		}).on('afterChange', (event, slick, currentSlide) => {
			el.find(`${WG}navLink`).removeClass(navActiveClass);
			el.find(`${WG}navLink[data-slide-index=${currentSlide}]`).addClass(navActiveClass);
		});

		$navPrev.on('click', () => {
			scrollPos = $navLinks.scrollLeft();
			if (scrollPos > 0) {
				scrollPos -= scrollDistance / 2;
				scrollPos = scrollPos < 0 ? 0 : scrollPos;
				$navLinks.animate({
					scrollLeft: scrollPos,
				}, 200);
			}
		});

		$navNext.on('click', () => {
			scrollPos = $navLinks.scrollLeft();
			if (scrollPos < scrollDistance) {
				scrollPos += scrollDistance / 2;
				scrollPos = scrollPos > scrollDistance ? scrollDistance : scrollPos;
				$navLinks.animate({
					scrollLeft: scrollPos,
				}, 200);
			}
		});
	}

	handleIframe() {
		let iframe = $('iframe.farmItem-modalContent');
		let modal = iframe.closest('.modal');

		modal.on('shown.bs.modal', () => {
			iframe.css({
				width: '100%',
				height: iframe.closest('.modal-body').height(),
			});

			modal.css({
				overflowY: 'hidden !important',
			});

			modal.find('.modal-body').css({
				overflowY: 'hidden !important',
			});

			modal.addClass('px-0');

			$(document.body).css({
				overflowY: 'hidden',
				maxHeight: '100vh',
				paddingRight: 0,
			});
		});

		modal.on('hidden.bs.modal', () => {
			$(document.body).css({
				overflowY: '',
				maxHeight: '',
				paddingRight: '',
			});

			document.documentElement.scrollTop = window.scrollPosition || 0;
		});
	}
}
